import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BoldBorderOutlineButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonRaisedButton from "../Common/CommonRaisedButton";
import { RAISED_BOLD_OUTLINE_BUTTONS, RAISED_BOLD_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/RaisedStyle";

const RaisedBoldBorderOutlineButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={BoldBorderOutlineButton} span={RAISED_BOLD_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn outline color="primary-2x" id="Tooltip-47" className="btn-pill btn-air-primary">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-47" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-outline-primary-2x btn-air-primary</ToolTip>
          {RAISED_BOLD_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonRaisedButton key={index} item={data} outline/>
          ))}
        </CardBody>
      </Card>
    );
};

export default RaisedBoldBorderOutlineButtons;
